import { render, staticRenderFns } from "./PolicyDocumentReadyToPublishNotification.vue?vue&type=template&id=810a1c9e&scoped=true&"
import script from "./PolicyDocumentReadyToPublishNotification.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentReadyToPublishNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810a1c9e",
  null
  
)

export default component.exports